// extracted by mini-css-extract-plugin
module.exports = {"listingPage":"_3YREj-P","advert":"B1jL7hg"};